<template>
  <section class="bg-white">
    <div class="p-10 px-4 pt-8 pb-4 mx-auto max-w-3xl md:pt-16 md:pb-8 lg:px-0">
      <div class="relative p-4 border-l-[5px] border-lifeboost-red border-t border-r border-b md:p-10 rounded-md">
        <svg
          class="absolute top-6 left-6 pointer-events-none"
          width="42"
          height="35"
          viewBox="0 0 42 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M15.5676 0.542583C17.3776 1.26658 18.2826 2.53358 18.2826 4.34358C18.2826 5.06758 18.1016 5.79158 17.7396 6.51558L12.4906 17.7376C14.0592 18.4616 15.3866 19.4269 16.4726 20.6336C17.5586 21.8402 18.1016 23.4089 18.1016 25.3396C18.1016 27.7529 17.2569 29.8646 15.5676 31.6746C13.8782 33.4846 11.7666 34.3896 9.23256 34.3896C6.69856 34.3896 4.52656 33.4846 2.71656 31.6746C0.906563 29.8646 0.00156257 27.7529 0.00156257 25.3396C0.00156257 23.8916 0.423896 22.3229 1.26856 20.6336L9.59456 2.71458C10.4392 0.904578 11.7062 -0.000421226 13.3956 -0.000421226C14.1196 -0.000421226 14.8436 0.18058 15.5676 0.542583ZM39.0976 0.542583C40.9076 1.26658 41.8126 2.53358 41.8126 4.34358C41.8126 5.06758 41.6316 5.79158 41.2696 6.51558L36.0206 17.7376C37.5892 18.4616 38.9166 19.4269 40.0026 20.6336C41.0886 21.8402 41.6316 23.4089 41.6316 25.3396C41.6316 27.7529 40.7869 29.8646 39.0976 31.6746C37.4082 33.4846 35.2966 34.3896 32.7626 34.3896C30.2286 34.3896 28.0566 33.4846 26.2466 31.6746C24.4366 29.8646 23.5316 27.7529 23.5316 25.3396C23.5316 23.8916 23.9539 22.3229 24.7986 20.6336L33.1246 2.71458C33.9692 0.904578 35.2362 -0.000421226 36.9256 -0.000421226C37.6496 -0.000421226 38.3736 0.18058 39.0976 0.542583Z"
            fill="#FDE8E6"
          />
        </svg>

        <figure
          class="relative z-10 mx-auto w-full sm:float-right sm:ml-6 max-w-[200px] lg:ml-12"
        >
          <div class="">
            <nuxt-img
              :src="founderImageSrc"
              :alt="founderImageAlt"
              width="215"
              height="285"
              format="webp"
              loading="lazy"
              sizes="xs:260px sm:215px"
              class="block w-full h-auto"
            />
          </div>
        </figure>

        <div
          class="relative z-10 pl-0 text-base md:text-17 md:!leading-8 text-black font-ww-regular sm:text-base [&_p+p]:mt-5 [&_p]:mt-0 [&_p:not(:first-child)]:mt-5"
          v-html="content"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  content: {
    type: String,
    default: `<p>Hi, I'm Dr Charles. CEO and Founder of Lifeboost Coffee. As I turned 40, I noticed my body slowing down. It was harder to recover from workouts. Harder to lose weight.</p>
<p>Harder to gain muscle. I would walk into a room and forget why I went in there in the first place. I think that's normal every once in a while, but I noticed it happening more often.</p>
<p>My immune system was taking a hit more often and I would get allergies and sinus infections. I also would notice how foods would affect my gut health. Dairy, wheat, sugar, carbs in general, seed oils, would cause bloating, gas, weight gain, even acid reflux. My joints were hurting from wear and tear and my cholesterol was increasing.</p>
<p>I didn't like it. Aging sucks. I still felt like I was 25 mentally but my body could tell I was not.</p>
<p>It was time to do something about it and I started to get deeper into biohacking, longevity and research to come up with ways to slow down aging.</p>
<p>This article is a culmination of a majority of things I take and supplement with. I will be 48 this year, and feel better now than I did in my thirties.</p>
<p>It's a simple list that I've accumulated over the years.</p>
<p>My advice? Don't try to do everything all at once. That sets you up for failure. Slowly add these into your daily life and form habits.</p>
<p>I hope it helps you as much as it has helped me!</p>`
  },
  founderImageSrc: {
    type: String,
    default: '/assets/images/dr-charlz-sign.png'
  },
  founderImageAlt: {
    type: String,
    default: 'Dr. Charles holding a cup of coffee'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Founder Story',
  inputs: [
    {
      name: 'content',
      type: 'richText',
      defaultValue: `<p>Hi, I'm Dr Charles. CEO and Founder of Lifeboost Coffee. As I turned 40, I noticed my body slowing down. It was harder to recover from workouts. Harder to lose weight.</p>
<p>Harder to gain muscle. I would walk into a room and forget why I went in there in the first place. I think that's normal every once in a while, but I noticed it happening more often.</p>
<p>My immune system was taking a hit more often and I would get allergies and sinus infections. I also would notice how foods would affect my gut health. Dairy, wheat, sugar, carbs in general, seed oils, would cause bloating, gas, weight gain, even acid reflux. My joints were hurting from wear and tear and my cholesterol was increasing.</p>
<p>I didn't like it. Aging sucks. I still felt like I was 25 mentally but my body could tell I was not.</p>
<p>It was time to do something about it and I started to get deeper into biohacking, longevity and research to come up with ways to slow down aging.</p>
<p>This article is a culmination of a majority of things I take and supplement with. I will be 48 this year, and feel better now than I did in my thirties.</p>
<p>It's a simple list that I've accumulated over the years.</p>
<p>My advice? Don't try to do everything all at once. That sets you up for failure. Slowly add these into your daily life and form habits.</p>
<p>I hope it helps you as much as it has helped me!</p>`
    },
    {
      name: 'founderImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/dr-charlz-sign.png'
    },
    {
      name: 'founderImageAlt',
      type: 'text',
      defaultValue: 'Dr. Charles holding a cup of coffee'
    }
  ]
})
</script>
